<template>
  <div
    class="modal-card"
  >
    <section class="modal-card-body">
      <div class="mg-bt-30px">
        {{ $t('request_objective_of_trading.since') }}
      </div>
      <div class="mg-bt-50px">
        {{ $t('request_objective_of_trading.if_user') }}
      </div>
      <div class="mg-bt-30px is-expanded">
        <b-field :label="$t('request_objective_of_trading.fill_objective')">
          <b-select
            v-validate="'required'"
            v-model="objective"
            :disabled="isLoading"
            :placeholder="$t('request_objective_of_trading.please_fill_objective')"
            name="objective"
            expanded
          >
            <option
              v-for="option in objectives"
              :value="option"
              :key="option.en">
              {{ option[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('objective') }}</span>
      </div>
      <div
        v-if="objective && objective.en === 'Other'"
        class="mg-bt-30px is-expanded"
      >
        <b-field :label="$t('request_objective_of_trading.please_fill')">
          <b-input
            v-validate="'required'"
            v-model="otherInput"
            :placeholder="$t('request_objective_of_trading.fill_reason')"
            maxlength="200"
            type="textarea"
            name="reason"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('reason') }}</span>
      </div>
      <b-button
        :loading="isLoading"
        class="button is-primary is-expanded"
        @click="submit"
      >
        {{ $t('request_objective_of_trading.submit') }}
      </b-button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RequestObjectiveOfTradingModal',
  inject: ['$validator'],
  data () {
    return {
      objectives: [
        { th: 'เพื่อเทรดเกร็งกำไร', en: 'Trade for profitably' },
        { th: 'แลกเปลี่ยนเหรียญที่ท่านชื่นชอบสะสม', en: 'Exchange coins you like to collect' },
        { th: 'ทํา Arbitrage', en: 'Make arbitrage' },
        { th: 'อื่นๆ', en: 'Other' }
      ],
      objective: null,
      otherInput: '',
      isLoading: false
    }
  },
  methods: {
    async submit () {
      const validateFieldResult = await this.$validator.validate()
      if (validateFieldResult) {
        let result = this.objective.th
        if (this.objective.en === 'Other') {
          result += ` เหตุผล: ${this.otherInput}`
        }
        this.isLoading = true
        this.$emit('onSubmit', result)
        this.$parent.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-body {
  padding: 50px;
}
.mg-bt-30px {
  margin-bottom: 30px;
}
.mg-bt-50px {
  margin-bottom: 50px;
}
.is-expanded {
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestObjectiveOfTradingModal.vue